
import { useState } from "react";
import  "./AcidityIntensity.css";
const AcidityIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.acidityintensity===0?0:data.acidityintensity);
  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
    
  }
    return (
  <div class="AcidityIntensityradiocard" name="acidityintensity" onChange={onChangeValue}>
    <div class="AcidityIntensityrating-container">
    
      <div class="AcidityIntensityrating">
        <form class="AcidityIntensityrating-form-1" >

          <label for={`ACI1F-${count}`}>
          <input type="radio"  name="acidityintensity" class="AcidityIntensity1" id={`ACI1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>

          <label for={`ACI2F-${count}`}>
          <input type="radio" name="acidityintensity" class="AcidityIntensity2" id={`ACI2F-${count}`} value="2" checked={'' + val === "2"} />
        <div className="circle">2</div>
          </label>

          <label for={`ACI3F-${count}`}>
        <input type="radio" name="acidityintensity" class="AcidityIntensity3" id={`ACI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>

          <label for={`ACI4F-${count}`}>
        <input type="radio" name="acidityintensity" class="AcidityIntensity4" id={`ACI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>

        </label>

          <label for={`ACI5F-${count}`}>
        <input type="radio" name="acidityintensity" class="AcidityIntensity5" id={`ACI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>


    );
}

export default AcidityIntensity;